import {
  FieldTypes,
  IFieldInstance,
} from "../../types/fieldInstance.interface";
import {
  getRLFormFields,
  incidentRelatedLists,
} from "../helpers/relatedListHelpers";
import { transformedData } from "./getTransformedData";
import { createRLHashTable } from "./rLViewModel";

const hashTable: {
  [x: string]: IFieldInstance;
} = {};

let inlineRLFields = {};

const createHashTable = (inputObject: { [x: string]: IFieldInstance[] }) => {
  for (let key in inputObject) {
    for (let field of inputObject[key]) {
      let id = field.id;
      if (!hashTable[id]) {
        hashTable[id] = field;
      }
      if (field.fieldType === FieldTypes.InlineRelatedList) {
        const formFieldsObj = getRLFormFields(field.fieldName);
        inlineRLFields = { ...inlineRLFields, ...formFieldsObj };
      }
      // what happens if two fields share the same id?
      // remove nested loop?
    }
  }
};

createHashTable(transformedData);

createHashTable(inlineRLFields);

const rlHashTable = Object.keys(incidentRelatedLists).reduce(
  (acc: any, current) => {
    const formFields = getRLFormFields(incidentRelatedLists[current]);
    acc[incidentRelatedLists[current]] = createRLHashTable(formFields);
    return acc;
  },
  {}
);

export const findFormfieldById = (
  id: string,
  relatedListName?: string,
  hashObject = relatedListName ? rlHashTable[relatedListName] : hashTable
) => {
  // Guard the lookup: an unknown relatedListName leaves hashObject undefined.
  return (hashObject && hashObject[id]) || null;
};

export const getFormFieldsByProperty = <T extends keyof IFieldInstance>(
  property: T,
  propertyValue: IFieldInstance[T],
  relatedListName?: string,
  hashObject = relatedListName ? rlHashTable[relatedListName] : hashTable,
  range = hashObject ? Object.keys(hashObject) : []
) => {
  return Object.values(hashObject).filter(
    (obj: any) => obj[property] === propertyValue && range.includes(obj.id)
  );
};
